import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BusinessPlatformSwitch, PlatformSwitch, PlatformSwitchKey } from '../models/platform-switches.model';

/**
 * AI › Feature switches and the business profile's Features panel (specs/agents spec-v1.7, owner decisions 2026-10-31): Agents, Plus
 * Intelligence and Micro apps, each on or off for every business, and for one business where it differs. The account API owns
 * `agent.PlatformSwitches` and `agent.BusinessPlatformSwitches` and audits each change; SuperAdmin only there.
 */
@Injectable({ providedIn: 'root' })
export class PlatformSwitchesService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/platform-switches';

  constructor(private http: HttpClient) {}

  /** One row per switch; a switch with no stored row comes back off. */
  list(): Observable<PlatformSwitch[]> {
    return this.http.get<PlatformSwitch[]>(this.baseUrl);
  }

  /** Sets one switch and returns it as saved. */
  set(key: PlatformSwitchKey, enabled: boolean): Observable<PlatformSwitch> {
    return this.http.put<PlatformSwitch>(`${this.baseUrl}/${encodeURIComponent(key)}`, { enabled });
  }

  /** One row per switch for the business. */
  listForBusiness(businessId: string): Observable<BusinessPlatformSwitch[]> {
    return this.http.get<BusinessPlatformSwitch[]>(`${this.baseUrl}/businesses/${encodeURIComponent(businessId)}`);
  }

  /** Sets the business's own setting; null makes it follow the platform again. */
  setForBusiness(businessId: string, key: PlatformSwitchKey, enabled: boolean | null): Observable<BusinessPlatformSwitch> {
    return this.http.put<BusinessPlatformSwitch>(`${this.baseUrl}/businesses/${encodeURIComponent(businessId)}/${encodeURIComponent(key)}`, { enabled });
  }
}
